import { APICore } from "./apiCore";

const api = new APICore();

function ApiGetAllProduct(params: any): any {
  const baseUrl = "/api/admin/product";
  return api.get(`${baseUrl}`, params);
}

function ApiPostProduct(params: any): any {
  const baseUrl = "/api/admin/product";
  return api.create(`${baseUrl}`, params);
}

function ApiEditProduct(id: any, params: any): any {
  const baseUrl = "/api/admin/product";
  return api.update(`${baseUrl}/${id}`, params);
}

export { ApiGetAllProduct, ApiPostProduct, ApiEditProduct };
